import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import HomePage from "./pages/HomePage";
import OurStoryPage from "./pages/OurStoryPage";
import ServicesPage from "./pages/ServicesPage";
import TransferPage from "./pages/TransferPage";
import RefillPage from "./pages/RefillPage";
import DeliveryPage from "./pages/DeliveryPage";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/our-story" element={<OurStoryPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/transfer" element={<TransferPage />} />
          <Route path="/refill" element={<RefillPage />} />
          <Route path="/delivery" element={<DeliveryPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
